import { FC } from 'react';
import { SubmissionErrorBoundary } from '../../components/errors/SubmissionErrorBoundary';
import { Modal } from '../../components/shared/modal/Modal';
import strings from '../devices/devices.translations';
import { AddDeviceForm } from './AddDeviceForm';

interface AddDeviceModalProps {
  locationId: number;
  open: boolean;
  onClose: () => void;
}

export const AddDeviceModal: FC<AddDeviceModalProps> = ({ open, onClose, locationId }) => {
  return (
    <Modal open={open} onClose={onClose} header={strings.addDeviceModal.title}>
      <SubmissionErrorBoundary>
        <AddDeviceForm onComplete={onClose} locationId={locationId} />
      </SubmissionErrorBoundary>
    </Modal>
  );
};
